import md5 from 'js-md5';
import addinstance from './instance.js'
import geturl from './seturl'
//平台菜单
export const menuindex= params=> {return addinstance().get(geturl(`/menu/index`),{params:params});}
export const createmenu= params => { return addinstance().post(geturl(`/menu/create`), params) };
export const updatemenu= params => { return addinstance().post(geturl(`/menu/update`), params) };
export const deletemenu= params => { return addinstance().post(geturl(`/menu/delete`), params) };
//集团菜单
export const company_menuindex= params=> {return addinstance().get(geturl(`/company_menu/index`),{params:params});}
export const company_createmenu= params => { return addinstance().post(geturl(`/company_menu/create`), params) };
export const company_updatemenu= params => { return addinstance().post(geturl(`/company_menu/update`), params) };
export const company_deletemenu= params => { return addinstance().post(geturl(`/company_menu/delete`), params) };
//集团菜单
export const hotel_menuindex= params=> {return addinstance().get(geturl(`/hotel_menu/index`),{params:params});}
export const hotel_createmenu= params => { return addinstance().post(geturl(`/hotel_menu/create`), params) };
export const hotel_updatemenu= params => { return addinstance().post(geturl(`/hotel_menu/update`), params) };
export const hotel_deletemenu= params => { return addinstance().post(geturl(`/hotel_menu/delete`), params) };
//会议菜单
export const meeting_menuindex= params=> {return addinstance().get(geturl(`/meeting_menu/index`),{params:params});}
export const meeting_createmenu= params => { return addinstance().post(geturl(`/meeting_menu/create`), params) };
export const meeting_updatemenu= params => { return addinstance().post(geturl(`/meeting_menu/update`), params) };
export const meeting_deletemenu= params => { return addinstance().post(geturl(`/meeting_menu/delete`), params) };




// WEBPACK FOOTER //
// ./src/api/menuapi.js